import moment from 'moment-timezone';

const TAIWAN_TIME_ZONE = 'Asia/Taipei';

const getMinBookingDate = () => {
  // get Taiwan local time
  const currentTaiwanTime = moment.tz(TAIWAN_TIME_ZONE);

  // Current formatted Taiwan Time
  const formattedTaiwanTime = moment(currentTaiwanTime.format('YYYY-MM-DD'));

  // Get current Taiwan Hour
  const currentTaiwanHour = +currentTaiwanTime.format('H');

  // Time of user's local machine
  const localCurrentTime = moment();

  const formattedLocalTime = moment(localCurrentTime.format('YYYY-MM-DD'));


  /**
   * If the Taiwan's time is greater than 21
   *
   * E.g:
   * TAIWAN: 2018-09-10 22:00
   *
   * Result Date should be: 2018-09-12
   *
   */
  if (currentTaiwanHour >= 21) {
    return formattedTaiwanTime.add(2, 'day');
  }

  /**
   * If the Taiwan's time is smaller than 21:00 (9 PM),
   * but the current Taiwan time is actuallly greater than users' local machine time
   *
   * E.g:
   * TAIWAN: 2018-09-10 01:00
   * USER's Machine: 2018-09-09
   *
   * Result Date should be: 2018-09-11
   *
   */
  if (formattedTaiwanTime > formattedLocalTime) {
    return formattedTaiwanTime.add(1, 'day');
  }

  /**
   * If the Taiwan's time is smaller than 21:00 (9 PM),
   * but the current Taiwan time is smaller or equal to users' local machine time
   *
   * E.g:
   * TAIWAN: 2018-09-10 01:00
   * USER's Machine: 2018-09-10
   *
   * Result Date should be: 2018-09-11
   *
   */
  return formattedTaiwanTime.add(1, 'day');
};

export default getMinBookingDate;
